import { apiBase } from "@/api/base";

export type HealthStatus = { status: string };

export async function fetchHealth(fetchImpl: typeof fetch = fetch): Promise<HealthStatus> {
  const res = await fetchImpl(`${apiBase()}/health`);
  if (!res.ok) {
    throw new Error(`API health check failed: HTTP ${res.status}`);
  }
  return (await res.json()) as HealthStatus;
}
